import { CORE_FIELD_VALUE_KIND } from './core-field-value-kind.js';
import { FIELD_TYPE_VALUE_KIND } from './field-type-value-kind.js';
import { CORE_FIELD_ID_SET } from './rule-types.js';
/** What runtime type a condition value must be for this field — 'none' when the field takes no comparison value (isSet/isEmpty only). */
export function valueKindForField(fieldId, fields) {
    if (CORE_FIELD_ID_SET.has(fieldId))
        return CORE_FIELD_VALUE_KIND[fieldId];
    const field = fields.find((candidate) => candidate.id === fieldId);
    return field ? FIELD_TYPE_VALUE_KIND[field.type] : undefined;
}
//# sourceMappingURL=value-kind-for-field.js.map